<template>
  <component :is="type" v-model="value"></component>
</template>

<script>
import * as Types from './types'
export default {
  props: ['type', 'value'],
  components: {
    ...Types
  }
}
</script>
